import { __rest, __assign } from '../../external/tslib/tslib.es6.mjs.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { useRef, useEffect } from 'react';
import clsx from 'clsx';
import { FormElement } from '../formElement/FormElement.js';
import styles from './Textarea.module.scss.js';

var Textarea = function (_a) {
    var _b;
    var _c;
    var id = _a.id, name = _a.name, maxLength = _a.maxLength, hasError = _a.hasError, label = _a.label, inputProps = _a.inputProps, _d = _a["aria-describedby"], ariaDescribedby = _d === void 0 ? '' : _d, className = _a.className, style = _a.style, showOptionalLabel = _a.showOptionalLabel, hintMessage = _a.hintMessage, autoFocus = _a.autoFocus, props = __rest(_a, ["id", "name", "maxLength", "hasError", "label", "inputProps", 'aria-describedby', "className", "style", "showOptionalLabel", "hintMessage", "autoFocus"]);
    var textareaRef = useRef(null);
    useEffect(function () {
        if (autoFocus) {
            textareaRef.current.focus();
        }
    }, [autoFocus]);
    var maxLengthMessage = maxLength ? (jsxs("span", __assign({ className: styles.maxLengthMsg }, { children: [((_c = inputProps.value) === null || _c === void 0 ? void 0 : _c.length) || 0, "/", maxLength] }))) : undefined;
    return (jsx(FormElement, __assign({ className: className, style: style, label: label, htmlFor: name, hintMessage: hintMessage || maxLengthMessage, hasError: hasError, showOptionalLabel: showOptionalLabel }, { children: jsx("textarea", __assign({ id: id || name, name: name, ref: textareaRef, "aria-describedby": ariaDescribedby, className: clsx(styles.textarea, (_b = {}, _b[styles.textareaError] = hasError, _b)), rows: 5 }, props, inputProps, { maxLength: maxLength })) })));
};

export { Textarea };
